import Chance from 'chance';
import cloneDeep from 'lodash/cloneDeep';

import { medicationGroups } from '~lib/common/config/medication';

const chance = new Chance();

export function copyMedication(caseConf, medications, medId, groupKey) {
  // Returns updates with existing and new customMedications and dosageForms
  const updates = {};

  const existingMed = findMedication(caseConf, medications, medId);
  const newMed = duplicateMediction(existingMed, groupKey);
  updates.customMedications = cloneDeep(caseConf.customMedications || []);
  updates.customMedications.push(newMed);
  const existingDosage = caseConf.dosageForms.find(df => df.medicationId === medId);
  if (existingDosage) {
    const newDosage = duplicateDosage(existingDosage, newMed.id);
    if (newDosage) {
      updates.dosageForms = cloneDeep(caseConf.dosageForms || []);
      updates.dosageForms.push(newDosage);
    }
  }
  return updates;
}

export function copyGroup(caseConf, medications, existingGroupKey) {
  // Returns updates with existing and new customMedGroups, customMedications, and dosageForms
  const updates = {};
  // Group
  const newGroupKey = chance.guid();
  const newGroup = {
    key: newGroupKey,
    label: cloneDeep(findGroup(caseConf, existingGroupKey).label)
  };
  newGroup.label.en += ' (copy)'
  updates.customMedGroups = cloneDeep(caseConf.customMedGroups || []);
  updates.customMedGroups.push(newGroup);

  // Medications
  const existingMeds = findMedications(caseConf, medications, existingGroupKey);
  const medIdMap = {};
  const newMeds = existingMeds.map(med => {
    const newMed = duplicateMediction(med, newGroupKey);
    medIdMap[med.id] = newMed.id;
    return newMed;
  });
  updates.customMedications = cloneDeep(caseConf.customMedications || []).concat(newMeds);

  // Dosage forms
  const existingDfs = caseConf.dosageForms.filter(
    df => existingMeds.find(m => m.id === df.medicationId)
  );
  const newDfs = existingDfs.map(df => {
    return duplicateDosage(df, medIdMap[df.medicationId]);
  })
  updates.dosageForms = cloneDeep(caseConf.dosageForms || []).concat(newDfs);

  return updates;
}

function duplicateMediction(med, newGroupKey) {
  const newMedId = chance.guid();
  const newCustomMed = {
    ...med,
    id: newMedId,
    key: newMedId,
    group: newGroupKey,
    routes: med.routes.map(r => {
      delete r.defaultUnits;
      delete r.defaultAdminTypes;
      return r;
    })
  };

  return newCustomMed;
}

function duplicateDosage(dosage, newMedId) {
  const newDosageId = chance.guid();
  const newDosage = {
    ...dosage,
    id: newDosageId,
    medicationId: newMedId
  };
  return newDosage;
}

function findGroup(caseConf, groupKey) {
  let group = medicationGroups.find(g => g.key === groupKey);
  if (!group) {
    group = caseConf.customMedGroups.find(g => g.key === groupKey);
  }
  return group;
}

function findMedication(caseConf, medications, medId) {
  let med = medications.find(m => m.id === medId);
  if (!med) {
    med = caseConf.customMedications.find(cm => cm.key === medId);
  }
  return med;
}

function findMedications(caseConf, medications, groupKey) {
  const allMeds = medications.concat(caseConf.customMedications || []);
  return allMeds.filter(med => med.group === groupKey);
}
